module.exports = __webpack_public_path__ + "img/windchill_logo.29da96c0.svg";